import { Skeleton } from "@/components/ui/skeleton";

/**
 * Height-preserving skeleton for mode-switch pages.
 * 
 * CRITICAL: This component maintains visual continuity during auth loading.
 * It renders INSIDE AppLayout, never wrapping it.
 * 
 * Golden Rule: "Once a shell is visible, the UI must never go empty."
 */
export function ContentSkeleton() {
  return (
    <div className="p-6 space-y-6">
      {/* Header area */}
      <div className="flex justify-between items-center">
        <Skeleton className="h-8 w-48" />
        <div className="flex gap-2">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-24" />
        </div>
      </div>
      
      {/* Filters area */}
      <div className="flex gap-4">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-10 w-32" />
        <Skeleton className="h-10 w-32" />
      </div>
      
      {/* Content rows */}
      <div className="space-y-3">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-16 w-full" />
        ))}
      </div>
    </div>
  );
}
